import React from 'react';

interface GlobalTagProps {
	description: React.ReactNode;
	backgroundColor?: string;
	size?: string;
}

export const GlobalTag: React.FC<GlobalTagProps> = (props) => {
	const { description, backgroundColor = '#ffffff', size = '48px' } = props;

	return (
		<div
			style={{
				display: 'flex',
				width: size,
				height: size,
				borderRadius: '100%',
				backgroundColor: backgroundColor,
				textAlign: 'center',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			{description}
		</div>
	);
};
